import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import { Link } from "react-router-dom";

import UTC2Local, { formatDateTimeToStringV2 } from "../../../../UTC2Local";

import LongText from "../../../../components/Text/LongText";

import "./stye.css";
import colors from "../../../../assets/theme/light/colors";

export function EmployeeTimesheetTable({
	t,
	data,
	handleOpenModal,
	generateTaskRoute,
}) {
	const {
		dateSummaries,
		taskSummaries,
		totalDuration,
		totalBillableDuration,
		totalNonBillableDuration,
	} = data;

	const displayDateDetailsCells = () => {
		const dateDetailsCells = [];

		dateDetailsCells.push(
			<TableCell
				sx={{
					textOverflow: "ellipsis",
					whiteSpace: "nowrap !important",
					overflow: "hidden",
					width: "20vw !important",
					minWidth: "auto",
					top: 0,
					left: 0,
					position: "sticky",
					backgroundColor: "#fff",
					zIndex: "3",
				}}
				key="footer-task-placeholder"
			>
				Total
			</TableCell>
		);

		dateSummaries.forEach((row, index) => {
			dateDetailsCells.push(
				<TableCell
					key={`footer-billable-${index}`}
					align="right"
					sx={{
						paddingRight: "1px",
						paddingLeft: 0,
						top: 0,
						left: 0,
						position: "sticky",
						width: "200px",
						backgroundColor: colors.light_color_blue_lighter_3,
						zIndex: "1",
						textAlign: "center",
					}}
				>
					{row?.billableDurationByDate}
				</TableCell>,
				<TableCell
					key={`footer-nonBillable-${index}`}
					align="right"
					sx={{
						paddingRight: "1px",
						paddingLeft: 0,
						width: "200px",
						top: 0,
						left: 0,
						position: "sticky",
						backgroundColor: colors.light_color_blue_lighter_2,
						zIndex: "1",
						textAlign: "center",
					}}
				>
					{row?.nonBillableDurationByDate}
				</TableCell>,
				<TableCell
					key={`footer-total-${index}`}
					align="right"
					sx={{
						fontWeight: "bold",
						paddingRight: "1px",
						paddingLeft: 0,
						top: 0,
						left: 0,
						position: "sticky",
						width: "200px",
						backgroundColor: colors.light_color_blue_lighter,
						zIndex: "1",
						textAlign: "center",
					}}
				>
					{row?.totalDurationByDate}
				</TableCell>
			);
		});

		dateDetailsCells.push(
			<TableCell
				align="right"
				sx={{
					paddingRight: "1px",
					paddingLeft: 0,
					top: 0,
					left: 0,
					position: "sticky",
					width: "200px",
					backgroundColor: colors.light_color_blue_lighter_3,
					zIndex: "1",
					textAlign: "center",
				}}
			>
				{totalBillableDuration}
			</TableCell>,
			<TableCell
				align="right"
				sx={{
					paddingRight: "1px",
					paddingLeft: 0,
					top: 0,
					left: 0,
					position: "sticky",
					width: "200px",
					backgroundColor: colors.light_color_blue_lighter_2,
					zIndex: "1",
					textAlign: "center",
				}}
			>
				{totalNonBillableDuration}
			</TableCell>,
			<TableCell
				align="right"
				sx={{
					fontWeight: "bold",
					paddingRight: "1px",
					paddingLeft: 0,
					top: 0,
					left: 0,
					position: "sticky",
					backgroundColor: colors.light_color_blue_lighter,
					width: "200px",
					zIndex: "1",
					textAlign: "center",
				}}
			>
				{totalDuration}
			</TableCell>
		);
		return dateDetailsCells;
	};

	const findTaskDurationForDate = (date, dateDetails) => {
		const matchingDate = dateDetails.find(
			(detail) => UTC2Local(detail.date, true) === UTC2Local(date, true)
		);
		return matchingDate
			? {
					billableDuration: matchingDate.billableDuration,
					nonBillableDuration: matchingDate.nonBillableDuration,
					totalDuration: matchingDate.totalDuration,
			  }
			: {
					billableDuration: "",
					nonBillableDuration: "",
					totalDuration: "",
			  };
	};

	return (
		<TableContainer component={Paper} className={"table-timesheet-height"}>
			<Table
				id="employee-timesheet-table"
				sx={{ tableLayout: "fixed", width: "100%" }}
				stickyHeader
				size="small"
				aria-label="a dense table"
			>
				<TableHead>
					<TableRow>
						{/* <TableCell sx={{ minWidth: "auto", width: "300px" }}>
              {t("employeeTimesheet.project")}
            </TableCell> */}
						<TableCell
							sx={{
								textOverflow: "ellipsis",
								whiteSpace: "nowrap !important",
								overflow: "hidden",
								width: "20vw !important",
								minWidth: "auto",
								top: 0,
								left: 0,
								position: "sticky",
								backgroundColor: "#fff",
								zIndex: "3",
							}}
						>
							{t("employeeTimesheet.task")}
						</TableCell>
						{dateSummaries.map((date, index) => (
							<React.Fragment key={index}>
								<TableCell
									align="right"
									sx={{ width: "200px", textAlign: "center" }}
									colSpan={3}
								>
									{formatDateTimeToStringV2(
										date?.date,
										false,
										true,
										null,
										false
									)}
								</TableCell>
							</React.Fragment>
						))}
						<TableCell
							align="right"
							sx={{ width: "200px", textAlign: "center" }}
							colSpan={3}
						>
							Total
						</TableCell>
					</TableRow>
					<TableRow>
						<TableCell
							sx={{
								textOverflow: "ellipsis",
								whiteSpace: "nowrap !important",
								overflow: "hidden",
								width: "20vw !important",
								minWidth: "auto",
								top: 0,
								left: 0,
								position: "sticky",
								backgroundColor: "#fff",
								zIndex: "3",
							}}
						></TableCell>
						{dateSummaries.map((date, index) => (
							<React.Fragment key={index}>
								<TableCell
									align="right"
									style={{
										width: "200",
										backgroundColor: "#f5f5f5",
										textAlign: "center",
									}}
								>
									B
								</TableCell>
								<TableCell
									align="right"
									style={{
										width: "200",
										backgroundColor: "#f5f5f5",
										textAlign: "center",
									}}
								>
									NB
								</TableCell>
								<TableCell
									align="right"
									style={{
										width: "200",
										backgroundColor: "#f5f5f5",
										textAlign: "center",
									}}
								>
									T
								</TableCell>
							</React.Fragment>
						))}
						<TableCell
							align="right"
							style={{
								width: "200px",
								backgroundColor: "#f5f5f5",
								textAlign: "center",
							}}
						>
							B
						</TableCell>
						<TableCell
							align="right"
							style={{
								width: "200px",
								backgroundColor: "#f5f5f5",
								textAlign: "center",
							}}
						>
							NB
						</TableCell>
						<TableCell
							align="right"
							style={{
								width: "200px",
								backgroundColor: "#f5f5f5",
								textAlign: "center",
							}}
						>
							T
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{taskSummaries.map((row, index) => {
						const { dateDetails } = row;
						const dateDetailsCells = [];
						dateSummaries.forEach((dateSummary) => {
							const {
								billableDuration,
								nonBillableDuration,
								totalDuration,
							} = findTaskDurationForDate(
								dateSummary?.date,
								dateDetails
							);
							dateDetailsCells.push(
								<TableCell
									key={`billable-${dateSummary.date}`}
									sx={{
										width: "200px",
										textAlign: "center",
										backgroundColor:
											colors.light_color_blue_lighter_3,
									}}
									align="right"
								>
									{billableDuration}
								</TableCell>,
								<TableCell
									key={`nonBillable-${dateSummary.date}`}
									sx={{
										width: "200px",
										textAlign: "center",
										backgroundColor:
											colors.light_color_blue_lighter_2,
									}}
									align="right"
								>
									{nonBillableDuration}
								</TableCell>,
								<TableCell
									key={`total-${dateSummary.date}`}
									sx={{
										fontWeight: "bold",
										width: "200px",
										textAlign: "center",
										backgroundColor: colors.light_color_blue_lighter,
									}}
									align="right"
								>
									{totalDuration}
								</TableCell>
							);
						});
						const taskTotals = row;
						dateDetailsCells.push(
							<TableCell
								sx={{
									width: "200px",
									textAlign: "center",
									backgroundColor: colors.light_color_blue_lighter_3,
								}}
								align="right"
							>
								{taskTotals.totalBillableDuration}
							</TableCell>,
							<TableCell
								align="right"
								sx={{
									width: "200px",
									textAlign: "center",
									backgroundColor: colors.light_color_blue_lighter_2,
								}}
							>
								{taskTotals.totalNonBillableDuration}
							</TableCell>,
							<TableCell
								align="right"
								sx={{
									fontWeight: "bold",
									width: "200px",
									textAlign: "center",
									backgroundColor: colors.light_color_blue_lighter,
								}}
							>
								{taskTotals.totalTaskDuration}
							</TableCell>
						);
						return (
							<TableRow
								key={row?.taskGuid}
								sx={{
									"&:last-child td, &:last-child th": { border: 0 },
								}}
							>
								{/* <TableCell
                    component={Link}
                    align="left"
                    className="link-cell"
                    sx={{ paddingRight: 0 }}
                    to={generateProjectRoute(row)}
                    onClick={(event) => handleOpenModal(event, row)}
                  >
                    {LongText({ text: row.projectTitle, length: 48 })}
                  </TableCell> */}
								<TableCell
									component={Link}
									align="left"
									className="link-cell task"
									sx={{
										paddingRight: 0,
										position: "sticky",
										top: 0,
										left: 0,
										backgroundColor: "#fff",
										textOverflow: "ellipsis",
										whiteSpace: "nowrap !important",
										overflow: "hidden",
									}}
									to={generateTaskRoute(row)}
									onClick={(event) => handleOpenModal(event, row)}
								>
									{LongText({
										text: `${row?.projectTitle} - ${row?.taskName}`,
										length: 70,
									})}
								</TableCell>
								{dateDetailsCells}
							</TableRow>
						);
					})}
					<TableRow>{displayDateDetailsCells()}</TableRow>
				</TableBody>
			</Table>
		</TableContainer>
	);
}
